<div fxLayout>
  <main fxFlex style="padding: 0px; margin-bottom: 0">
    <picture>
      <source srcset="assets/images/demo/inbox/inbox.webp" type="image/webp" />
      <img src="assets/images/demo/inbox/inbox.svg" class="demo-ux-image" (load)="isImageLoaded = true" />
    </picture>

    <div class="demo-callout rules__intro-text" *ngIf="isImageLoaded">
      <div fxFlex>
        <ng-container *ngIf="userTrialConnectAccountCta$ | async as userTrialConnectAccountCta">
          <h2>See messages from all platforms in one place!</h2>
          <p class="notification__description">
            The Hospitable.com Inbox is your one-stop shop for everything communication. You can expect to see every new
            message sent or received from the guests, as well as new inquiries and requests to book, on this page.
          </p>
          <p class="notification__description">
            Connect your {{ userTrialConnectAccountCta?.platformUi | titlecase }} account to import your listings into
            your Hospitable.com account and start using the Inbox today to manage all your communication!
          </p>

          <div class="rules__intro-buttons" fxLayout fxLayout.lt-md="column" fxLayoutGap="16px">
            <button mat-flat-button (click)="clickedPrimaryCta(userTrialConnectAccountCta.connectAccountUrl)">
              Connect with {{ userTrialConnectAccountCta?.platformUi | titlecase }}
            </button>

            <a
              mat-flat-button
              class="button__secondary"
              (click)="
                clickedSecondaryCta(
                  'https://my.hospitable.com/support-documentation/article/5625480-getting-started-with-the-inbox'
                )
              ">
              Learn more
            </a>
          </div>
        </ng-container>
      </div>
      <div fxFlex class="notification__video" fxShow fxHide.lt-md>
        <iframe
          id="video-iframe"
          iframeTracker
          (iframeClick)="clickedVideo()"
          src="https://www.loom.com/embed/db8e6efd7e774e058b3c15e6ba9f65a5"
          frameborder="0"
          webkitallowfullscreen
          mozallowfullscreen
          allowfullscreen
          style="width: 100%; height: 100%"
          (click)="clickedVideo()"></iframe>
      </div>
    </div>
  </main>
</div>
